import {SidebarReleases as ReleasesComponent} from '@github-ui/code-view-sidebar/components/SidebarReleases'
import {isCombinedSidebarPayloadEnabled} from '@github-ui/code-view-sidebar/is-enabled'
import type {SidebarReleasesResponse} from '@github-ui/code-view-sidebar/types'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
  /** Total number of published releases (from the about payload). */
  releaseCount: number
  /** Total number of tags (from the about payload). */
  tagCount: number
}

export function SidebarReleases(props: Props) {
  return isCombinedSidebarPayloadEnabled() ? (
    <SidebarReleasesCombined {...props} />
  ) : (
    <SidebarReleasesIndividual {...props} />
  )
}

function SidebarReleasesCombined({ownerLogin, repoName, releaseCount, tagCount}: Props) {
  const {releases} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!releases) return null
  return <ReleasesComponent {...releases} releaseCount={releaseCount} tagCount={tagCount} />
}

function SidebarReleasesIndividual({ownerLogin, repoName, releaseCount, tagCount}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'releases', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/releases`)
      if (!r.ok) throw new Error(`Sidebar releases fetch failed (${r.status})`)
      return (await r.json()) as SidebarReleasesResponse
    },
  })

  if (!data) return null
  return <ReleasesComponent {...data} releaseCount={releaseCount} tagCount={tagCount} />
}
